// extracted by mini-css-extract-plugin
export default {"anchor":"DownloadNowAnchor_anchor__hqUwN","label":"DownloadNowAnchor_label__0Op--","icon":"DownloadNowAnchor_icon__PlmoH"};